import classes from "./FrontBox.module.scss"
import Backdrop from "./Backdrop";
import kids from './../../../assets/kids.mp4';
export const FrontBox = () => (
    <div className={classes.FrontBox}>
        <Backdrop/>
        {/*<YoutubeEmbed embedId={'fgqEyC19538'} />*/}
        <video src={kids} autoPlay loop muted></video>
    </div>
);
